import React from 'react';
import styles from './MaterialitySelector.module.scss';
import { Materiality } from '../../../types/projectDocumentation';
import { ArrowLeft } from 'lucide-react';
import CheckIcon from '../../../assets/iconsTsx/CheckIcon.tsx';

interface MaterialitySelectorProps {
  materialities: Materiality[];
  selectedMateriality: string | null;
  onSelect: (materialityId: string) => void;
  onBack: () => void;
}

const MaterialitySelector: React.FC<MaterialitySelectorProps> = ({
  materialities,
  selectedMateriality,
  onSelect,
  onBack
}) => {
  const handleMaterialitySelect = (materialityId: string) => {
    onSelect(materialityId);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h2 className={styles.title}>Selecciona la materialidad</h2>
          <p className={styles.description}>
            Elige el tipo de materialidad principal de tu anteproyecto
          </p>
        </div>
        <button className={styles.backButton} onClick={onBack}>
          <ArrowLeft size={16} />
          Volver
        </button>
      </div>

      <div className={styles.materialitiesGrid}>
        {materialities.map((materiality) => (
          <div
            key={materiality.id}
            className={`${styles.materialityCard} ${
              selectedMateriality === materiality.id ? styles.selected : ''
            }`}
            onClick={() => handleMaterialitySelect(materiality.id)}
          >
            <div className={styles.materialityIcon}>
              <div className={styles.iconPlaceholder}>
                {materiality.name.charAt(0).toUpperCase()}
              </div>
            </div>
            <h3 className={styles.materialityName}>{materiality.name}</h3>
            {selectedMateriality === materiality.id && (
              <div className={styles.checkmark}>
                <CheckIcon className={styles.checkIcon} />
              </div>
            )}
          </div>
        ))}
      </div>

      {materialities.length === 0 && (
        <div className={styles.emptyState}>
          <p>No hay materialidades disponibles</p>
        </div>
      )}

    </div>
  );
};

export default MaterialitySelector;
